module.exports = __webpack_public_path__ + "img/prompt_bg.572548d0.svg";